import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.tips.company.item');
import { Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-tips-company-item',
template: templateSource || '',
    styles: [``],
})
export class PortalLpsysadminTipsCompanyItemComponent implements OnInit, OnChanges {
    @Input() status: string = 'recommended';
    @Input() company_id: string = '';
    @Input() section: string = 'overview';

    constructor(@Inject( Service) public service: Service) { }

    public initialized: boolean = false;
    public loading: boolean = false;
    public loaded: boolean = false;
    public saving: boolean = false;
    public uploadingFiles: boolean = false;
    public data: any = {};
    public budget: any[] = [];
    public kpis: any = { goals: [], methods: [] };
    public milestones: any[] = [];
    public requests: any[] = [];
    public baseTab: string = 'budget';

    public sections: any[] = [
        { key: 'overview', label: '관리현황' },
        { key: 'base', label: '팁스 기초데이터' },
        { key: 'requests', label: '증빙·자료요청' }
    ];

    public baseTabs: any[] = [
        { key: 'budget', label: '사업비' },
        { key: 'kpi', label: 'KPI' },
        { key: 'schedule', label: '기업 개발일정' }
    ];

    public evidenceTypes: string[] = ['연구노트', '근태기록', '사업비 증빙', 'KPI 증빙', '개발일정 증빙', '회의록', '성과자료', '기타'];
    public requestStatuses: string[] = ['요청전', '요청중', '제출완료', '보완요청', '확인완료'];

    public statusClassMap: any = {
        '요청전': 'border-zinc-200 bg-zinc-50 text-zinc-600',
        '요청중': 'border-sky-200 bg-sky-50 text-sky-700',
        '제출완료': 'border-emerald-200 bg-emerald-50 text-emerald-700',
        '보완요청': 'border-amber-200 bg-amber-50 text-amber-700',
        '확인완료': 'border-violet-200 bg-violet-50 text-violet-700',
        '기한초과': 'border-red-200 bg-red-50 text-red-700'
    };

    public evidenceClassMap: any = {
        '연구노트': 'bg-sky-50 text-sky-700 border-sky-200',
        '근태기록': 'bg-emerald-50 text-emerald-700 border-emerald-200',
        '사업비 증빙': 'bg-amber-50 text-amber-700 border-amber-200',
        'KPI 증빙': 'bg-violet-50 text-violet-700 border-violet-200',
        '개발일정 증빙': 'bg-rose-50 text-rose-700 border-rose-200'
    };

    public overviewCards: any[] = [
        { key: 'base', label: '기초데이터', value: '0/4' },
        { key: 'active', label: '진행 요청', value: '0' },
        { key: 'submitted', label: '제출 검토', value: '0' },
        { key: 'overdue', label: '기한초과', value: '0' }
    ];

    public async ngOnInit() {
        await this.service.init();
        this.initialized = true;
        await this.load();
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) return;
        if (changes.company_id) await this.load();
        else {
            if (changes.section && ['budget', 'kpi', 'schedule'].includes(this.section || '')) {
                this.baseTab = this.section;
            }
            await this.service.render();
        }
    }

    public activeSection(): string {
        const key = this.section || 'overview';
        if (['budget', 'kpi', 'schedule'].includes(key)) return 'base';
        return this.sections.some((item: any) => item.key === key) ? key : 'overview';
    }

    public sectionLabel(): string {
        const found = this.sections.find((item: any) => item.key === this.activeSection());
        return found ? found.label : '관리현황';
    }

    public sectionClass(key: string): string {
        if (this.activeSection() === key) return 'border-amber-500 bg-amber-50 text-amber-800';
        return 'border-zinc-200 bg-white text-zinc-600 hover:border-amber-300 hover:text-amber-700';
    }

    public async goSection(key: string) {
        if (!this.company_id) return;
        this.service.href(`/admin/tips/company/${this.status || this.data.status || 'recommended'}/${this.company_id}/${key}`);
    }

    public backToList() {
        this.service.href(`/admin/tips/company/${this.status || this.data.status || 'recommended'}`);
    }

    public async load() {
        if (!this.company_id || this.loading) return;
        this.loading = true;
        this.loaded = false;
        await this.service.render();
        const { code, data } = await wiz.call('get', { id: this.company_id });
        this.loading = false;
        if (code !== 200) {
            await this.service.alert.error(data?.message || '팁스 기업 정보를 불러오지 못했습니다.');
            this.backToList();
            return;
        }
        this.applyData(data.data || {});
        this.loaded = true;
        await this.service.render();
    }

    public applyData(row: any) {
        this.data = row || {};
        this.budget = this.normalizeBudget(row.business_expenses);
        this.kpis = this.normalizeKpis(row.kpis);
        this.milestones = this.normalizeMilestones(row.development_schedules);
        this.requests = this.normalizeRequests(row.management_requests);
        if (['budget', 'kpi', 'schedule'].includes(this.section || '')) this.baseTab = this.section;
    }

    public activeBaseTab(): string {
        return ['budget', 'kpi', 'schedule'].includes(this.baseTab) ? this.baseTab : 'budget';
    }

    public async setBaseTab(key: string) {
        this.baseTab = key;
        await this.service.render();
    }

    public baseTabClass(key: string): string {
        if (this.activeBaseTab() === key) return 'border-amber-500 bg-amber-50 text-amber-800';
        return 'border-zinc-200 bg-white text-zinc-600 hover:border-amber-300 hover:text-amber-700';
    }

    public normalizeRequests(items: any) {
        if (!Array.isArray(items)) return [];
        return items.map((item: any, index: number) => ({
            id: item?.id || `REQ-${Date.now()}-${index}`,
            title: item?.title || item?.evidence_type || '자료 요청',
            evidence_type: item?.evidence_type || '연구노트',
            phase: ['1', '2', '3'].includes(String(item?.phase || '')) ? String(item.phase) : '1',
            period: item?.period || '',
            request_date: item?.request_date || '',
            due_date: item?.due_date || '',
            status: item?.status || '요청전',
            owner: item?.owner || '',
            message: item?.message || '',
            admin_files: Array.isArray(item?.admin_files) ? item.admin_files : [],
            submitted_files: Array.isArray(item?.submitted_files) ? item.submitted_files : [],
            memo: item?.memo || ''
        }));
    }

    public baseSummary() {
        const budget = this.budget.reduce((count: number, phase: any) => {
            return count + (phase.items || []).filter((item: any) => item.cash || item.in_kind).length;
        }, 0);
        return {
            budget,
            kpiGoals: this.kpis.goals.length,
            kpiMethods: this.kpis.methods.length,
            milestones: this.milestones.length,
            completed: [budget > 0, this.kpis.goals.length > 0, this.kpis.methods.length > 0, this.milestones.length > 0].filter(Boolean).length
        };
    }

    public requestSummary() {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const overdue = this.requests.filter((item: any) => this.isOverdue(item, today)).length;
        return {
            total: this.requests.length,
            active: this.requests.filter((item: any) => ['요청전', '요청중', '보완요청'].includes(item.status)).length,
            submitted: this.requests.filter((item: any) => item.status === '제출완료').length,
            completed: this.requests.filter((item: any) => item.status === '확인완료').length,
            overdue
        };
    }

    public isOverdue(item: any, baseDate: Date = new Date()): boolean {
        if (!item?.due_date || ['제출완료', '확인완료'].includes(item.status)) return false;
        const due = new Date(item.due_date);
        due.setHours(0, 0, 0, 0);
        const today = new Date(baseDate);
        today.setHours(0, 0, 0, 0);
        return due.getTime() < today.getTime();
    }

    public statusClass(item: any): string {
        if (this.isOverdue(item)) return this.statusClassMap['기한초과'];
        return this.statusClassMap[item?.status] || this.statusClassMap['요청전'];
    }

    public evidenceClass(type: string): string {
        return this.evidenceClassMap[type] || 'bg-zinc-50 text-zinc-600 border-zinc-200';
    }

    public latestRequests(limit: number = 5) {
        return [...this.requests].sort((a: any, b: any) => {
            return String(a.due_date || '').localeCompare(String(b.due_date || ''));
        }).slice(0, limit);
    }

    public defaultBudgetItems() {
        return [
            '인건비',
            '학생인건비',
            '연구시설·장비비',
            '연구재료비',
            '연구활동비',
            '연구수당',
            '보안수당',
            '위탁연구개발비',
            '국제공동연구개발비',
            '연구개발부담비',
            '간접비'
        ].map((category: string) => ({ category, cash: '', in_kind: '', memo: '' }));
    }

    public normalizeBudget(items: any) {
        const source = Array.isArray(items) ? items : [];
        return ['1차', '2차', '3차'].map((phase: string) => {
            const found = source.find((item: any) => item?.phase === phase) || {};
            const rows = Array.isArray(found.items) ? found.items : [];
            const extra = rows.filter((item: any) => item?.category && !this.defaultBudgetItems().some((base: any) => base.category === item.category));
            return {
                phase,
                memo: found.memo || '',
                items: this.defaultBudgetItems().map((base: any) => {
                    const row = rows.find((item: any) => item?.category === base.category) || {};
                    return {
                        category: base.category,
                        cash: row.cash || '',
                        in_kind: row.in_kind || '',
                        memo: row.memo || ''
                    };
                }).concat(extra.map((item: any) => ({
                    category: item.category || '',
                    cash: item.cash || '',
                    in_kind: item.in_kind || '',
                    memo: item.memo || ''
                })))
            };
        });
    }

    public normalizeKpis(value: any) {
        const source = value && typeof value === 'object' ? value : {};
        return {
            goals: Array.isArray(source.goals) ? source.goals.map((item: any) => ({
                evaluation_item: item.evaluation_item || '',
                unit: item.unit || '',
                target_value: item.target_value || '',
                basis: item.basis || ''
            })) : [],
            methods: Array.isArray(source.methods) ? source.methods.map((item: any) => ({
                evaluation_item: item.evaluation_item || '',
                evaluation_method: item.evaluation_method || '',
                evaluation_environment: item.evaluation_environment || ''
            })) : []
        };
    }

    public normalizeMilestones(items: any) {
        if (!Array.isArray(items)) return [];
        return items.map((item: any, index: number) => ({
            phase: ['1', '2', '3'].includes(String(item?.phase || '')) ? String(item.phase) : String((index % 3) + 1),
            detail: item?.detail || '',
            organization: item?.organization || '',
            period_months: item?.period_months || ''
        }));
    }

    public money(value: any): number {
        const text = String(value || '').replace(/[^0-9.-]/g, '');
        const amount = Number(text);
        return isNaN(amount) ? 0 : amount;
    }

    public phaseTotal(phase: any, field: string): number {
        return (phase.items || []).reduce((sum: number, item: any) => sum + this.money(item[field]), 0);
    }

    public formatMoney(value: any): string {
        const amount = this.money(value);
        if (!amount) return '-';
        return amount.toLocaleString();
    }

    public addBudgetCategory(phase: any) {
        phase.items.push({ category: '', cash: '', in_kind: '', memo: '' });
        this.service.render();
    }

    public removeBudgetCategory(phase: any, index: number) {
        phase.items.splice(index, 1);
        this.service.render();
    }

    public addKpiGoal() {
        this.kpis.goals.push({ evaluation_item: '', unit: '', target_value: '', basis: '' });
        this.service.render();
    }

    public removeKpiGoal(index: number) {
        this.kpis.goals.splice(index, 1);
        this.service.render();
    }

    public addKpiMethod() {
        this.kpis.methods.push({ evaluation_item: '', evaluation_method: '', evaluation_environment: '' });
        this.service.render();
    }

    public removeKpiMethod(index: number) {
        this.kpis.methods.splice(index, 1);
        this.service.render();
    }

    public addMilestone() {
        this.milestones.push({ phase: '1', detail: '', organization: '', period_months: '' });
        this.service.render();
    }

    public removeMilestone(index: number) {
        this.milestones.splice(index, 1);
        this.service.render();
    }

    public addRequest() {
        const today = new Date().toISOString().slice(0, 10);
        this.requests.unshift({
            id: `REQ-${Date.now()}`,
            title: '자료 요청',
            evidence_type: '연구노트',
            phase: '1',
            period: '',
            request_date: today,
            due_date: '',
            status: '요청전',
            owner: this.data.tips_manager || '',
            message: '',
            admin_files: [],
            submitted_files: [],
            memo: ''
        });
        this.service.render();
    }

    public removeRequest(index: number) {
        this.requests.splice(index, 1);
        this.service.render();
    }

    public async uploadRequestFiles(item: any, field: string) {
        if (!item || !field || this.uploadingFiles) return;
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        if (!Array.isArray(item[field])) item[field] = [];
        this.uploadingFiles = true;
        await this.service.render();
        try {
            for (let i = 0; i < files.length; i++) {
                const fd = new FormData();
                fd.append('upload', files[i]);
                const { url } = await this.service.file.upload('/file/upload', fd, () => { });
                item[field].push({ name: files[i].name, url });
            }
        } catch (e) {
            await this.service.alert.error('파일 업로드에 실패했습니다.');
        }
        this.uploadingFiles = false;
        await this.service.render();
    }

    public async removeRequestFile(item: any, field: string, index: number) {
        if (!item || !Array.isArray(item[field])) return;
        item[field].splice(index, 1);
        await this.service.render();
    }

    public phaseClass(phase: string): string {
        if (phase === '1') return 'border-sky-200 bg-sky-50 text-sky-700';
        if (phase === '2') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        return 'border-amber-200 bg-amber-50 text-amber-700';
    }

    public async saveBudget() {
        if (this.saving) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('save_budget', {
            data: JSON.stringify({ id: this.company_id, business_expenses: this.budget })
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.alert.error(data?.message || '사업비 저장에 실패했습니다.');
            await this.service.render();
            return;
        }
        this.applyData(data.data || this.data);
        await this.service.alert.success('사업비가 저장되었습니다.');
        await this.service.render();
    }

    public async saveKpi() {
        if (this.saving) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('save_kpi', {
            data: JSON.stringify({ id: this.company_id, kpis: this.kpis })
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.alert.error(data?.message || 'KPI 저장에 실패했습니다.');
            await this.service.render();
            return;
        }
        this.applyData(data.data || this.data);
        await this.service.alert.success('KPI가 저장되었습니다.');
        await this.service.render();
    }

    public async saveSchedule() {
        if (this.saving) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('save_schedule', {
            data: JSON.stringify({ id: this.company_id, development_schedules: this.milestones })
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.alert.error(data?.message || '기업 개발일정 저장에 실패했습니다.');
            await this.service.render();
            return;
        }
        this.applyData(data.data || this.data);
        await this.service.alert.success('기업 개발일정이 저장되었습니다.');
        await this.service.render();
    }

    public async saveRequests() {
        if (this.saving) return;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('save_requests', {
            data: JSON.stringify({ id: this.company_id, management_requests: this.requests })
        });
        this.saving = false;
        if (code !== 200) {
            await this.service.alert.error(data?.message || '증빙 요청 저장에 실패했습니다.');
            await this.service.render();
            return;
        }
        this.applyData(data.data || this.data);
        await this.service.alert.success('증빙 요청이 저장되었습니다.');
        await this.service.render();
    }
}

export default PortalLpsysadminTipsCompanyItemComponent;